import React, { useState, useEffect } from 'react';
import AppLinks from './display/AppLinks';

const BANNER_DATA = [
    {
        image: '/images/banner1.png',
        title: 'Trade Your Toys',
        subheading: 'Connect with parents across Pakistan',
        detail: 'The easiest way to exchange pre-loved toys and find something new for your kids.'
    },
    {
        image: '/images/banner1.png',
        title: 'Safe & Secure',
        subheading: 'Rating based accounts',
        detail: 'Every user is verified to ensure a trustworthy and safe environment for trading.'
    },
    {
        image: '/images/app_flat.png',
        title: 'Quick Listings',
        subheading: 'Post in Seconds',
        detail: 'Simply take a photo, add a description, and your toy is ready to be swapped or sold.'
    }
];

const HomeBanner = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % BANNER_DATA.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="home-banner">
            {BANNER_DATA.map((banner, index) => {
                const status = index === currentIndex ? 'active' :
                    index === (currentIndex - 1 + BANNER_DATA.length) % BANNER_DATA.length ? 'past' :
                        'next';
                return (
                    <div
                        key={index}
                        className={`banner-slide ${status}`}
                        aria-hidden={status !== 'active'}
                    >
                        <div
                            className="banner-bg"
                            style={{ backgroundImage: `url(${banner.image})` }}
                        ></div>
                        <div className="m-4 h-100">
                            <div className="row h-100 align-items-center">
                                <div className="col-lg-6 banner-text-side">
                                    <div className="banner-text-content">
                                        <h1 className="display-3 fw-bold mb-2 animate-text">{banner.title}</h1>
                                        <h2 className="fs-2 mb-3 text-primary animate-text-delay-1">{banner.subheading}</h2>
                                        <p className="lead fs-4 mb-0 animate-text-delay-2">{banner.detail}</p>
                                        <AppLinks className="mt-4" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            {/* Navigation Dots */}
            <div className="banner-dots">
                {BANNER_DATA.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    ></button>
                ))}
            </div>
        </div>
    );
};

export default HomeBanner;
